module.exports = __webpack_public_path__ + "media/feature-icons/workflow-aa55ef0b.png";